import { ObjectStateEnum } from '../../../shared/model/dtoBase.model';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from 'src/app/shared/widgets/value-accessors/object-value-accessor';
import { CustomFieldValueDto } from '../dto/custom-field-value.dto';
import { CustomFieldService } from '../custom-field.service';
import { CustomFieldDto } from '../dto/custom-field.dto';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ProfileCustomField } from '../model/profile-custom-field.model';

@Component({
  selector: 'wl-profile-custom-field',
  templateUrl: './profile-custom-field.component.html',
  styleUrls: ['./profile-custom-field.component.less'],
  providers: [
    CreateObjectValueAccessorProvider(ProfileCustomFieldComponent),
    CreateObjectValueValidationProvider(ProfileCustomFieldComponent),
  ],
  standalone: false
})
export class ProfileCustomFieldComponent implements OnInit, OnChanges {
  @Input() editable: boolean;
  @Input()
  get field() {
    return this._field;
  }
  set field(val) {
    this._field = val;
    this.fieldChange.emit(this._field);

  }
  @Output() fieldChange = new EventEmitter<CustomFieldDto>();

  @Input()
  get profileCustomField() {
    return this._profileCustomField;
  }
  set profileCustomField(val: ProfileCustomField) {
    this._profileCustomField = val;
    this.profileCustomFieldChange.emit(this._profileCustomField);
  }
  @Output() profileCustomFieldChange = new EventEmitter<ProfileCustomField>();

  @Input() showHeader = true;
  @Input() showDelete = true;
  @Output() delete: EventEmitter<any> = new EventEmitter();

  public customFieldValues: CustomFieldValueDto[];
  private _selectedCustomFieldValue: CustomFieldValueDto;
  private _field: CustomFieldDto;
  private _profileCustomField: ProfileCustomField;

  constructor(private _customFieldService: CustomFieldService) {
    this.customFieldValues = [];
  }

  ngOnInit() {
    if (this.field?.DisplayType?.toLowerCase() === 'drop down list') {
      this._customFieldService.getCustomFieldValues(this.field.CustomFieldID).then((data) => {
        this.customFieldValues = data;
        this._selectedCustomFieldValue = this.customFieldValues.find((x) => x.FieldValue === this._profileCustomField?.FieldValue);
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  get inputType() {
    switch (this.field.DataType) {
      case 'String':
        return 'text';
      case 'Integer':
      case 'Decimal':
        return 'number';
      default:
        return 'text';
    }
  }

  get selectedDropdownItem() {
    return this._selectedCustomFieldValue;
  }
  set selectedDropdownItem(value: CustomFieldValueDto) {
    this._profileCustomField.FieldValue = value.FieldValue;
    this._selectedCustomFieldValue = value;
  }

  onFieldChange() {
    this._profileCustomField.ObjectState = ObjectStateEnum.Modified;
  }
}
